// 수학 출제하기 화면(MathBankPage)의 작은 조각들: 칩 목록, 거르는 조건, 문제 카드.
// 스타일은 MathBankPage.css (모든 선택자가 .math-bank-page 로 시작한다)
import React from "react";

import { DB_OPTION_LIST, KIND_LABEL, OWNER_LABEL, SOURCE_OPTION_LIST, imageListOf, plainMathText } from "./mathBankShared";

export const toggleInList = (list, value) =>
  list.includes(value) ? list.filter((one) => one !== value) : [...list, value];

export const MathBankChipList = ({ optionList, isActive, onPick }) => (
  <div className="math-bank-page__chip-list">
    {optionList.map((one) => (
      <button
        key={one.value}
        type="button"
        className={`math-bank-page__chip${isActive(one.value) ? " math-bank-page__chip--active" : ""}`}
        aria-pressed={isActive(one.value)}
        onClick={() => onPick(one.value)}
      >
        {one.label}
      </button>
    ))}
  </div>
);

export const MathBankField = ({ label, children }) => (
  <div className="math-bank-page__field">
    <div className="math-bank-page__label">{label}</div>
    {children}
  </div>
);

// 출처(내 문항 · 문제은행) · 쌍둥이 · 손필기 해설 · 원본/변형. 두 탭(범위 · 내 DB)이 같은 값을 쓴다
export const MathBankFilterFields = ({ filter, onChange }) => {
  const update = (patch) => onChange({ ...filter, ...patch });
  return (
    <>
      <MathBankField label="문항 출처">
        <MathBankChipList
          optionList={DB_OPTION_LIST}
          isActive={(value) => filter.dbList.includes(value)}
          onPick={(value) => {
            const nextList = toggleInList(filter.dbList, value);
            // 둘 다 끄면 아무것도 안 나온다. 마지막 하나는 끌 수 없다
            if (nextList.length) update({ dbList: nextList });
          }}
        />
      </MathBankField>
      <MathBankField label="유사 문제 · 해설">
        <MathBankChipList
          optionList={[
            { value: "hasTwin", label: "유사 문제 있는 것" },
            { value: "hasHandwrittenExplain", label: "손필기 해설 있는 것" },
          ]}
          isActive={(value) => filter[value]}
          onPick={(value) => update({ [value]: !filter[value] })}
        />
      </MathBankField>
      {filter.dbList.includes("mine") && (
        <MathBankField label="원본 · 변형">
          <MathBankChipList
            optionList={SOURCE_OPTION_LIST}
            isActive={(value) => value === filter.source}
            onPick={(value) => update({ source: value })}
          />
        </MathBankField>
      )}
    </>
  );
};

// 문제 한 줄. 위에 번호와 배지(난이도 · 형식 · 출처 · 쌍둥이 · 손필기 해설), 아래에 문제 글 · 그림 · 보기
export const MathBankProblemCard = ({ problem, index, checkbox = null, actionList = null, isChecked = false }) => {
  const ownerLabel = OWNER_LABEL[problem.owner || problem.db];
  const typeName = problem.type_name || problem.skill_name || problem.type_label;
  const handwrittenExplainUrl = problem.handwritten_explain_url || problem.detail_pdf_url;
  return (
    <li className={`math-bank-page__problem${isChecked ? " math-bank-page__problem--checked" : ""}`}>
      <div className="math-bank-page__problem-meta">
        {checkbox}
        <span className="math-bank-page__number">{index + 1}</span>
        {ownerLabel && (
          <span
            className={`math-bank-page__badge${
              (problem.owner || problem.db) === "mine" ? " math-bank-page__badge--mine" : ""
            }`}
          >
            {ownerLabel}
          </span>
        )}
        {problem.difficulty_label && <span className="math-bank-page__badge">{problem.difficulty_label}</span>}
        {KIND_LABEL[problem.answer_type] && <span className="math-bank-page__badge">{KIND_LABEL[problem.answer_type]}</span>}
        {problem.origin && (
          <span className="math-bank-page__badge">{problem.origin === "original" ? "원본" : "변형"}</span>
        )}
        {problem.twin_count > 0 && (
          <span className="math-bank-page__badge math-bank-page__badge--twin">유사 문제 {problem.twin_count}</span>
        )}
        {handwrittenExplainUrl ? (
          <a
            className="math-bank-page__badge math-bank-page__badge--explain"
            href={handwrittenExplainUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            손필기 해설
          </a>
        ) : (
          problem.has_handwritten_explain && (
            <span className="math-bank-page__badge math-bank-page__badge--explain">손필기 해설</span>
          )
        )}
        {actionList && <span className="math-bank-page__problem-actions">{actionList}</span>}
      </div>
      {typeName && <div className="math-bank-page__type-name">{typeName}</div>}
      <div className="math-bank-page__question">{plainMathText(problem.question)}</div>
      {imageListOf(problem).map((url) => (
        <img key={url} className="math-bank-page__image" src={url} alt="" loading="lazy" />
      ))}
      {(problem.choice_list || []).length > 0 && (
        <div className="math-bank-page__choice-list">
          {problem.choice_list.map((choice, choiceIndex) => (
            <span key={choiceIndex}>
              {choiceIndex + 1}. {plainMathText(choice)}
            </span>
          ))}
        </div>
      )}
    </li>
  );
};
